<template>
	<inertia-head title="Video Live Schedule" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Video Live Schedule</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Video Live Schedule List</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<h5>
			<div class="form-check form-switch form-check-inline">
				<input
					class="form-check-input"
					type="checkbox"
					:value="filter"
					:id="filter"
					name="filter"
					:checked="filter"
					@change="changeFilter()"
				/>
				<label class="form-check-label fw-semibold" for="filter">
					{{ filter==0 ? 'PAST EVENT' : 'UPCOMING' }}
				</label>
			</div>
		</h5>
		<div class="text-end mb-4">
			<button @click="viewVideoLiveScheduleModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Schedule
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>HOST BY</th>
								<th>TOPIC</th>
								<th>START</th>
								<th>END</th>
								<th>STATUS</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(content, c_index) in contents"
								:key="content.live_sched_id"
							>
								<td>{{content.host_by}}</td>
								<td>{{content.title}}</td>
								<td>{{content.start_datetime_display}}</td>
								<td>{{content.end_datetime_display}}</td>
								<td>
									<span v-if="content.is_active==1" class="text-success">Yes</span>
									<span v-if="content.is_active==0" class="text-danger">No</span>
								</td>
								<td>{{content.created_at}}</td>
								<td nowrap="" class="text-end">
									<button @click="viewVideoLiveScheduleModal(c_index,'update')" type="button" class="btn btn-sm btn-alt-info m-1"><i class="fa fa-pencil-alt"></i></button>
									<button @click="deleteSchedule(content.live_sched_id)" type="button" class="btn btn-sm btn-alt-danger"><i class="fa fa-times"></i></button>
								</td>
							</tr>
							<tr v-if="contents.length <= 0">
								<td colspan="7" class="mb-0 fw-semibold text-center p-5">NO VIDEO LIVE SCHEDULE FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<modal ref="deleteModal" size="modal-md">
			<template #title>
				Delete Confirmation
			</template>
			<template #body>
				<div class="mb-4">
					<p class="h5">Are you sure, you want to delete this details?</p>
				</div>
			</template>
			<template #footer>
				<button @click="confirmDeleteSchedule" type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button>
				<button type="button" class="btn btn-sm btn-secondary" @click="deleteModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
			</template>
		</modal>

		<add-update-video-live-schedule-modal ref="addUpdateVideoLiveScheduleModal" :content="selectedVideoLiveSchedule"/>

	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import AddUpdateVideoLiveScheduleModal from '../../Components/Admin/AddUpdateVideoLiveScheduleModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		contents	: Object,
		filter 		: String,
		search 		: String,
		api_response: Object
	},
	components:{AddUpdateVideoLiveScheduleModal},
	setup(props) {
		
		const search = ref(props.search);

		const action = ref('add');
		const filter = ref(props.filter);

		const selected_live_sched_id = ref(0);

		const toast = createToaster();

		const selectedVideoLiveSchedule = reactive({});

		const deleteModal 						= ref(null);
		const addUpdateVideoLiveScheduleModal 	= ref(null);

		const changeFilter = () => {

				if(filter.value==1)
				{
					filter.value=0;
				}else
				{
					filter.value=1;
				}

				Inertia.get(route('admin.video-live-schedule',{
						filter 		: filter.value
					})
				)
			}

		const viewVideoLiveScheduleModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedVideoLiveSchedule.live_sched_id 	= props.contents[_index].live_sched_id;
				selectedVideoLiveSchedule.membership_level 	= props.contents[_index].membership_level;
				selectedVideoLiveSchedule.host_by 			= props.contents[_index].host_by;
				selectedVideoLiveSchedule.title 			= props.contents[_index].title;
				selectedVideoLiveSchedule.start_datetime 	= props.contents[_index].start_datetime;
				selectedVideoLiveSchedule.end_datetime 		= props.contents[_index].end_datetime;
				selectedVideoLiveSchedule.is_active 		= props.contents[_index].is_active;
			}

			addUpdateVideoLiveScheduleModal.value.setVideoLiveSchedule(_action,selectedVideoLiveSchedule);

			addUpdateVideoLiveScheduleModal.value.toggleModal();

		}

		const deleteSchedule = (_live_sched_id)=>{
			selected_live_sched_id.value = _live_sched_id;
			deleteModal.value.toggleModal();
		}

		const confirmDeleteSchedule = ()=>{
			action.value = "delete";
			Inertia.delete('video-live-schedule/'+selected_live_sched_id.value,
			{
				preserveState: true,
				preserveScroll: true,
				only:['contents','api_response'],
				onSuccess:()=> {
					selected_live_sched_id.value = 0;
					deleteModal.value.toggleModal();
				}
			})
		}

		watch(search, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {search:value}

				if(value=="null")
				{
					param = "";
				}

				Inertia.get(
						'/admin/video-live-schedule', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['contents', 'search']
						}
					)
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return{
			search,
			action,
			toast,
			selected_live_sched_id,
			deleteSchedule,
			deleteModal,
			viewVideoLiveScheduleModal,
			selectedVideoLiveSchedule,
			changeFilter,
			confirmDeleteSchedule,
			addUpdateVideoLiveScheduleModal
		}
	},
}
</script>
